// @ts-nocheck
// plugins/taboola.client.ts
import { afterInteraction } from '../common/afterInteraction';

export default defineNuxtPlugin(() => {
  const PIXEL_ID = 1856107;
  const SCRIPT_ID = 'tb_tfa_script';
  const SCRIPT_SRC = `//cdn.taboola.com/libtrc/unip/${PIXEL_ID}/tfa.js`;

  window._tfa = (window as any)._tfa || [];

  const taboolaPushEvent = (eventName: string) => {
    window._tfa = (window as any)._tfa || [];
    (window as any)._tfa.push({ notify: 'event', name: eventName, id: PIXEL_ID });
  };

  afterInteraction().then(() => {
    if (!document.getElementById(SCRIPT_ID)) {
      const s = document.createElement('script');
      s.async = true;
      s.src = SCRIPT_SRC;
      s.id = SCRIPT_ID;
      document.head.appendChild(s);
    }
  });

  return {
    provide: {
      taboolaPushEvent,
    },
  };
});
